import type { Theme } from '@opallabs/gem'
import { kuiperClassNames } from '../utils/kuiperClassNames'

import './styles.scss'

const dotTheme = (theme?: LoaderThemes): Theme => {
  if (theme === undefined) return 'light'
  if (['n1', 'n2', 'n3', 'n4', 'n5', 'dark'].includes(theme)) return 'dark'
  return 'light'
}

type LoaderThemes =
  | 'blue'
  | 'n1'
  | 'n2'
  | 'n3'
  | 'n4'
  | 'n5'
  | 'n6'
  | 'n7'
  | 'n8'
  | 'n9'
  | 'n10'
  | 'transparent'
  | 'white'
  | 'dark'
  | 'light'

type BaseLoaderProps = {
  dotSize?: 'medium' | 'small'
  loaded: boolean
  theme?: LoaderThemes
  translucent?: boolean
}

const BaseLoader: React.FC<BaseLoaderProps> = ({
  dotSize,
  loaded,
  theme,
  translucent,
}) => (
  <div
    className={kuiperClassNames('loader-container', theme, {
      loaded,
      translucent,
    })}
  >
    <div className={kuiperClassNames('loader', dotSize, dotTheme(theme))}>
      <div />
    </div>
  </div>
)

export type LoaderProps = BaseLoaderProps & { minHeight?: number }

const Loader: React.FC<LoaderProps> = ({
  loaded,
  minHeight,
  dotSize = 'medium',
  theme = 'n3',
  translucent = false,
}) => {
  if (minHeight) {
    return (
      <div style={{ minHeight: loaded ? '0' : minHeight }}>
        <BaseLoader
          dotSize={dotSize}
          loaded={loaded}
          theme={theme}
          translucent={translucent}
        />
      </div>
    )
  }

  return (
    <BaseLoader
      dotSize={dotSize}
      loaded={loaded}
      theme={theme}
      translucent={translucent}
    />
  )
}

export default Loader
